
import React from "react";
import { useRoutes } from "react-router-dom";
import PublicRoutes from "./publicRoutes";
import AdminRoutes from "./adminRoutes";
import OrganizerRoutes from "./organizerRoutes";
import ParticipantRoutes from "./participantRoutes";
import AuthRoutes from "./authRoutes";
import NotFound from "@/pages/NotFound";

const AppRoutes = () => {
  const allRoutes = [
    ...PublicRoutes,
    ...AdminRoutes(),
    ...OrganizerRoutes(),
    ...ParticipantRoutes(),
    ...AuthRoutes(),
    {
      path: "*",
      element: <NotFound />
    }
  ];
  
  return useRoutes(allRoutes);
};

export default AppRoutes;
